export default ".search {\n  width: 100%;\n}\n\n.ui-card-body {\n  padding: 0 !important;\n}\n\n.mb-p-card {\n  margin-bottom: 0 !important;\n}";